import { FC, useState } from "react";
import { Alert, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CountryForm } from "../countryForm";
import { useSubmitCountryOnboardingRequest } from "../../admin/countryOnboardingRequests/queries";

export const RequestNewCountry: FC = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const submitRequest = useSubmitCountryOnboardingRequest({
    onSuccess: () =>
      navigate("/countries/my-requests", {
        state: { submitted: true }
      }),
    onError: (error) => setErrorMessage(error.message)
  });

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 1080,
        marginX: "auto",
        overflowY: "auto",
        paddingBottom: 3
      }}
    >
      {errorMessage && (
        <Alert severity="error" sx={{ marginTop: 2 }}>
          {errorMessage}
        </Alert>
      )}
      <CountryForm
        onSubmit={(payload) => {
          setErrorMessage(null);
          submitRequest.mutate(payload);
        }}
        submitting={submitRequest.isPending}
        submitLabel="Submit request"
        onCancel={() => navigate("/countries")}
      />
    </Box>
  );
};
